import { useUserState } from "../../context/UserContext";
import AdminOverview from "./admin/AdminOverview";
import StudentOverview from "./student/index";

const Profile = () => {
  const { userRole } = useUserState();

  return (
    <>
      {userRole?.role === "school_admin" ? (
        <AdminOverview />
      ) : <StudentOverview />}
    </>
  );
};

export default Profile;
